// eslint-disable-next-line import/prefer-default-export
export const INVALID_PHONE_ERROR_CODE = 'validation.invalid.phone';
